<template>
  <div
    class="ccui-multifunctional-table-wrapper ccui-multifunctional-table-wrapper-detail"
  >
    <template v-if="type != 2">
      <div class="operate">
        <el-upload
          :data="formData"
          :action="uploadForm.action"
          :before-upload="beforeAvatarUpload"
          :on-success="uploadSuccess"
          :show-file-list="false"
          :on-error="uploadError"
          :on-progress="onProgress"
          :headers="uploadForm.headers"
          multiple
          class="upload-demo tow"
        >
          <!-- 上传附件 -->
          <el-button plain type="single-number">{{
            $t("page.content.upload8")
          }}</el-button>
        </el-upload>
      </div>
      <div class="clearfix"></div>
      <br />
    </template>
    <el-table :data="fileData" border :header-cell-class-name="must">
      <template slot="empty" v-if="flag == 1">
        <!-- 未购买资格预审文件，购买后可下载资格预审文件 -->
        <span style="color:red">{{ $t("page.content.noBuy") }}</span>
      </template>
      <!-- 您还未上传附件信息 -->
      <template slot="empty" v-else>
        <span>{{ empty }}</span>
      </template>
      <!-- 序号 -->
      <el-table-column type="index" :label="$t('page.content.No')" width="50" />
      <!-- 发布时间 -->
      <el-table-column
        v-if="isChallenge"
        prop="createTime"
        :label="$t('page.content.Publish')"
        show-overflow-tooltip
        min-width="170"
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.createTime | formatTime1 }}
          </span>
        </template>
      </el-table-column>
      <!-- 附件名称 -->
      <el-table-column
        prop="fileName"
        :label="$t('page.content.name')"
        show-overflow-tooltip
        min-width="180"
      ></el-table-column>
      <!-- 附件大小 -->
      <el-table-column
        prop="fileSize"
        :label="$t('page.content.Size')"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="{ row }"> {{ row.fileSize }}kb </template>
      </el-table-column>
      <!-- 附件说明 -->
      <el-table-column
        prop="fileSumm"
        :label="$t('page.content.Description')"
        show-overflow-tooltip
        :min-width="languagezh_cn ? 120 : 160"
      >
        <template slot-scope="scope">
          <template v-if="type != 2 && !scope.row.isSubmit">
            <!-- 请输入附件说明 -->
            <el-input
              :placeholder="$t('page.content.leaseEnterAttached')"
              v-model="scope.row.fileSumm"
              maxlength="500"
              show-word-limit
              class="fileDesc"
            ></el-input>
          </template>
          <template v-else>
            <span>{{ scope.row.fileSumm }}</span>
          </template>
        </template>
      </el-table-column>
      <!-- 上传时间 -->
      <el-table-column
        v-if="isUpDateTime && isChallenge == false"
        prop="createTime"
        :label="$t('page.content.uploadTime')"
        show-overflow-tooltip
        width="170"
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.createTime | formatTime1 }}
          </span>
        </template>
      </el-table-column>
      <!-- 上传时间 -->
      <el-table-column
        v-if="isUpDateTime == false && isChallenge == false"
        prop="uploadTime"
        :label="$t('page.content.uploadTime')"
        show-overflow-tooltip
        width="170"
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.uploadTime | formatTime1 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        type="action"
        :label="$t('page.content.operation')"
        :width="languagezh_cn ? 120 : 150"
      >
        <template slot-scope="scope">
          <!-- 下载 -->
          <el-button type="text" @click="downloadUrlFile(scope.row)">{{
            $t("page.content.Download")
          }}</el-button>
          <!-- 预览 -->
          <template v-if="type == 2">
            <el-button type="text" @click="preview(scope.row)">{{
              $t("page.content.Yulan")
            }}</el-button>
          </template>
          <!-- 删除 -->
          <template v-if="type != 2">
            <el-button
              type="text"
              @click="deleteRow(scope.$index, scope.row)"
              >{{ $t("page.content.Delete") }}</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!--- 上传附件填写基本信息 -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { addUrlPerFix, getPreviewUrl } from "@/basa/utils";
import { savefile } from "@/basa/api/";
import { Loading } from "ccui";
export default {
  name: "attachmentUpload",
  props: {
    fileData: {
      type: Array,
      default() {
        return [];
      }
    },
    isChallenge: {
      //是否供应商质疑
      type: Boolean,
      default: false
    },
    type: {
      type: Number, // 0：修改、新增 1:复制 2： 查看详情
      default: 0
    },
    flag: {
      type: Number, // 0：修改、新增 1:复制 2： 查看详情
      default: 0
    },
    isUpDateTime: {
      type: Boolean,
      default: false
    },
    headerMust: {
      type: Boolean,
      default: false
    },
    empty: {
      type: String,
      //您还未上传附件信息
      default: window.$t("page.content.upload")
    }
  },
  computed: {
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    }
  },
  watch: {
    fileData(val) {
      console.log(val);
      this.fileData = val;
    }
  },
  data() {
    return {
      //提示
      emptytext: window.$t("page.content.tip"),
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL + "/apis/bid/oss/uploadFileToOssAndSave"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      uploadLoading: null,
      // fileData: [],
      formData: {
        agentId: this.$router.history.current.query.a
      },
      // fileTableData: this.fileData,
      deletePlanAttachementList: [] // 删除的数据
    };
  },
  deactivated() {
    this.fileData = [];
    this.deletePlanAttachementList = [];
    this.uploadLoading && this.uploadLoading.close();
  },
  methods: {
    must(obj) {
      if (
        this.headerMust &&
        ["fileName", "fileSize", "createTime", "uploadTime"].includes(
          obj.column.property
        )
      ) {
        return "must";
      }
    },
    async uploadSuccess(res, file, fileList) {
      this.uploadLoading.close();
      let fileData1 = res.data[0];
      let fileNameDuplication = false;
      if (this.fileData && this.fileData.length > 0) {
        this.fileData.forEach(item => {
          if (fileData1.fileName == item.fileName) {
            fileNameDuplication = true;
          }
        });
      }
      if (fileNameDuplication) {
        //请不要上传重名附件，请编辑后重新上传
        this.$message({
          message: window.$t("page.content.pleaseNot"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      } else if (!fileData1.uploadId) {
        //上传ID不能为空！请重新上传文件
        this.$message({
          message: window.$t("page.content.idNull"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      } else if (!fileData1.downloadUrl) {
        //文件URL不能为空！请重新上传文件
        this.$message({
          message: window.$t("page.content.urlNull"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }
      //附件上传成功
      this.$message.success(window.$t("page.content.attachmentSuccess"));

      await savefile({ uploadIds: fileData1.uploadId }).then(obj => {
        fileData1.downloadUrl = obj.data.data.fileInfoList[0].ossUrl;
      });

      this.fileData.push({
        fileUrl: fileData1.downloadUrl,
        fileName: fileData1.fileName,
        fileSize: Math.round(fileData1.fileSize / 1024),
        fileSumm: "",
        uploadTime: fileData1.createTime,
        fileinfoType: fileData1.fileType,
        uploadId: fileData1.uploadId
      });
      this.$emit("setFileUploadData", this.fileData);
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading.close();
    },
    onProgress(event, file, fileList) {
      //上传中,请稍等...
      this.uploadLoading = Loading.service({
        lock: true,
        text: window.$t("page.content.isUploading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
    },
    beforeAvatarUpload(file) {
      console.log(file);
      //上传中,请稍等...
      this.uploadLoading = Loading.service({
        lock: true,
        text: window.$t("page.content.isUploading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "XLSX" ||
        testmsg === "XLS" ||
        testmsg === "doc" ||
        testmsg === "docx" ||
        testmsg === "ppt" ||
        testmsg === "pptx" ||
        testmsg === "pdf" ||
        testmsg === "jpg" ||
        testmsg === "png" ||
        testmsg === "txt" ||
        testmsg === "rft" ||
        testmsg === "msg" ||
        testmsg === "wps" ||
        testmsg === "et" ||
        testmsg === "dps" ||
        testmsg === "vsd" ||
        testmsg === "prn" ||
        testmsg === "ai" ||
        testmsg === "cad" ||
        testmsg === "JPG" ||
        testmsg === "PNG" ||
        testmsg === "PDF" ||
        testmsg === "tiff" ||
        testmsg === "TIFF" ||
        testmsg === "swf" ||
        testmsg === "SWF" ||
        testmsg === "bmp" ||
        testmsg === "gif" ||
        testmsg === "jpeg" ||
        testmsg === "jpe" ||
        testmsg === "rar" ||
        testmsg === "RAR" ||
        testmsg === "zip" ||
        testmsg === "7z" ||
        testmsg === "lzh" ||
        testmsg === "LZH";
      if (!isLt50) {
        if (this.uploadLoading) {
          this.uploadLoading.close();
        }
        //文件大小不可超过50M！如超过50M请拆分上传！
        this.$message({
          message: window.$t("page.content.fileSizeOver"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("文件大小不可超过30M！");
      }
      if (!extension) {
        if (this.uploadLoading) {
          this.uploadLoading.close();
        }
        //上传文件格式错误！
        this.$message({
          message: window.$t("page.content.fileSizeErr"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && extension;
    },
    // 下载含有url的文件
    downloadUrlFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
      console.log(openUrl, "openUrl");
    },
    deleteRow(index, row) {
      if (row.pkRelation) {
        this.deletePlanAttachementList.push(row.pkRelation);
      }
      this.fileData.splice(index, 1);
    },
    //预览
    preview({ fileUrl }) {
      getPreviewUrl(fileUrl);
      //const previewSrc = getPreviewUrl(fileUrl);
      //window.open(previewSrc);
    }
  }
};
</script>

<style lang="scss" scoped>
.operate {
  float: right;
}
.upload-demo {
  margin-bottom: 20px;
}
.fileDesc /deep/ .el-input__inner {
  padding-right: 60px;
}
//.el-table /deep/ .cell {
//  height: 36px !important;
//  line-height: 36px !important;
//}
</style>
